// eslint-disable-next-line import/prefer-default-export
export const RESOURCE_TYPES = Object.freeze({
  VIDEO: `video`,
  AUDIO: `audio`,
  PDF: `pdf`,
})
